
























import { defineComponent } from '@vue/composition-api';
import HelpTooltip from '@front-app/components/dropdowns/HelpTooltip.vue';
import HelpTooltipBlock from '@front-app/components/dropdowns/HelpTooltipBlock.vue';
import TrCheckbox from '@front-app/components/inputs/Checkbox.vue';
import FormSection from '@front-app/components/form/FormSection.vue';

export default defineComponent({
	components: {
		FormSection,
		HelpTooltip,
		HelpTooltipBlock,
		TrCheckbox,
	},
	props: {
		textMainLine: {
			type: String,
			required: true,
		},
		textHelpLine1: {
			type: String,
			required: true,
		},
	},
});
